<template>
  <!-- <div style="width: 62%;margin: 3rem auto;" v-if='onlinestate=="pc"'>
    <div class='look_g'><div></div>{{params.foot_greentitle}}</div>
    <div class='img_text' style="font-size: 16px;">{{params.foot_texta}}</div>
    <div class='text_a'>{{params.foot_underline}}</div>
    <div class='img_text' v-for='(v,i) in params.foot_pic1'>
      <img :src="params.picsever + v.id" alt="">
      {{v.words}}</div>
    <div class='my_btn' @click='hanopen'>{{islang=='eng'?'Apply Now':'立即申請'}}</div>
    <div class='look_l'>{{params.foot_textb}}</div>
  </div>
  <div style="width: 90%;margin: 0rem auto 1rem;" v-else>
    <div class='look_g'><div></div>{{params.foot_greentitle}}</div>
    <div class='img_text'>{{params.foot_texta}}</div>
    <div class='text_a'>{{params.foot_underline}}</div>
    <div class='img_text' v-for='(v,i) in params.foot_pic1'>
      <img :src="params.picsever + v.id" alt="">
      {{v.words}}</div>
    <div class='my_btn' @click='hanopen'>{{islang=='eng'?'Apply Now':'立即申請'}}</div>
    <div class='look_l'>{{params.foot_textb}}</div>
  </div> -->
</template>

<script>
  export default{
    data(){
      return {
        islang : window.localStorage.guanwanglang,
        onlinestate:sessionStorage['onlinestate'],
        params:{
          foot_greentitle: "",
          foot_pic1: [{words: "", id: '',},],
          foot_texta: "",
          foot_textb: "",
          foot_underline: "",
          picsever: "",
        }
      }
    },
    mounted(){
      this.getdate()
    },
    methods:{
      hanopen(){
         this.$router.push('/account_opening_online')
      },
      getdate(){
        this.$ajax({
          method:'post',
          url:this.$api.getWelcomeToJoin,
          // data:{lan:window.localStorage.guanwanglang}
        }).then(res=>{
          this.params = res.data
        })
        console.log(this.params)
      }
    }
  }
</script>

<style scoped>

  .my_btn:hover{
    color: #fff;
    background-color: #0097a8
    /* #09666E; */
  }

  .my_btn{
    width: 6rem;
    border: 1px solid #0097a8;
    /* rgb(9, 102, 110); */
    padding: .5rem 0;
    text-align: center;
    margin: 1.2rem 0;
    font-size: 16px;
    color: #0097a8;
    cursor: pointer;
  }

  .img_text{
    margin: .5rem 0;
    font-size: 16px;
  }

  .img_text img{
    width: 1.6rem;
  }

  .text_a{
        text-decoration: underline;
        font-size: 16px;
        margin: .5rem 0;
  }

  .look_l{
    font-size: 16px;
    margin-bottom: .2rem;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/foot/footmess.vue